export default {"src":"/_next/static/media/children-pool.c49a496b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};